// extracted by mini-css-extract-plugin
module.exports = {"line":"DeleteCommentModel__line--1Q46m"};